import { render } from "./CheckListSb.vue?vue&type=template&id=1b9578db"
import script from "./CheckListSb.vue?vue&type=script&lang=js"
export * from "./CheckListSb.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__